import { createSlice } from "@reduxjs/toolkit";

export type EnergyStat = {
  id: "installations" | "autarky" | "serviceTime";
};

export type EnergyHighlight = {
  id: "turnkey" | "energyCheck" | "funding";
  status: "live" | "draft" | "planned";
};

export type EnergyState = {
  region: string;
  gridStatusId: "windowOpen";
  lastUpdate: string;
  stats: EnergyStat[];
  highlights: EnergyHighlight[];
};

const initialState: EnergyState = {
  region: "Baden-Württemberg",
  gridStatusId: "windowOpen",
  lastUpdate: "06.02.2026 · 09:15 Uhr",
  stats: [
    { id: "installations" },
    { id: "autarky" },
    { id: "serviceTime" }
  ],
  highlights: [
    {
      id: "turnkey",
      status: "live",
    },
    {
      id: "energyCheck",
      status: "draft",
    },
    {
      id: "funding",
      status: "planned",
    },
  ],
};

const energySlice = createSlice({
  name: "energy",
  initialState,
  reducers: {},
});

export const energyReducer = energySlice.reducer;
